<script setup lang="ts">
    import { computed } from 'vue';
    import { useSearchContext } from '../composables/searchContext';
    const search = useSearchContext();
    const division = computed(() => {
        const value = search.state.division.replace('b2b', '');
        return value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : value;
    });
    const catalogueHasProducts = () => Object.values(search.divisionCounts).some((count) => count > 0);
</script>

<template>
    <section id="NoResultDiv" class="search-container" role="status">
        <div class="noRresult">
            <div id="NoResultAlert" class="alert warning-alert">
                <h2 class="Nosearch-resulth3">OOPS!</h2>
                <div class="error-message-body">
                    <p class="warning-text">We found <strong>0 results</strong> for your search <strong>“{{ search.state.query }}”</strong> in the {{ division }} division. Please try another search.</p>
                </div>
                <div class="noresult-leftdivision">
                    <p>Not sure what you're looking for?</p>
                    <div>
                        <a class="Noresult-browsecatBtn" :href="`/search/q/_/division/${search.state.division}`">Browse the {{ division }} Catalogue</a>
                    </div>
                </div>

                <div class="NoResult-Cms" v-html="search.cmsContent.value.ConfigContent"></div>
            </div>
        </div>
    </section>
</template>
